import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 定时广播 列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	planTaskList( params={} ) {
		return request({
	    url: baseUrl + '/device/plan',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 定时广播 添加
	**/
	planTaskAdd(data){
		return request({
			url: baseUrl + '/device/plan',
			method:'POST',
			data
		})
	},

	/**
	 * 定时广播 编辑
	**/
	planTaskEdit(id,data){
		return request({
			url: baseUrl + '/device/plan/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 定时广播 删除
	**/
	planTaskDel(id){
		return request({
			url: baseUrl + '/device/plan/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 定时广播 是否开启
	 * @param {plan_id} 计划id
	 * @return {ste} 0关闭1开启
	**/
	planTaskSet(data){
		return request({
			url: baseUrl + '/device/planSet',
			method:'POST',
			data
		})
	}
}